export default "__VITE_ASSET__aaDDEXhI__"